export const ADD_USER_DETAILS = "ADD_USER_DETAILS";
export const FETCH_ALL_USER = "FETCH_ALL_USER";
export const EDIT_USER_DETAILS = "EDIT_USER_DETAILS";
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const DELETE_USER_DETAILS = "DELETE_USER_DETAILS";
export const CHANGE_ACTION = "CHANGE_ACTION";
export const ADD_DETAIL_TO_TABLE = "ADD_DETAIL_TO_TABLE";
